
/**
 * @nullable
 */
export type CreateCourseDraftBodyPrice = {
  /** 가격 금액 */
  amount: number;
  /** 통화 코드 (ISO 4217) */
  currency: string;
} | null;
